import React, { useState, useEffect, Children } from "react";
import { useParams, useNavigate } from "react-router-dom";
import {  Divider, Form, Input, message, Button} from "antd";
import { CloseOutlined, ArrowLeftOutlined } from "@ant-design/icons";

import {ROLE_OPTIONS, ROLE_TYPE_OPTIONS, SUPPORTED_JOB_CATEGORY, SUPPORTED_LOCATION, WORK_OPTIONS} from "../../../helper/categoryconstants" 
import "./nujobsApplyNowAfterLogin.scss";
import TextArea from "antd/es/input/TextArea";
import logo from "../../../assets/landingFeatures/explorer_cropped.png";
import { Space,Modal } from "antd";
import useNuJobDetailsStore from "../../../store/nujobsdetails.store";
import useNuJobsStore from "../../../store/nujobs.store";
import DOMPurify from "dompurify";

export default function NuJobsApplyNowAfterLogin({}) {
    const [isEditMode, setIsEditMode] = useState(false);
    const [formKey, setFormKey] = useState(1);
    const [form] = Form.useForm();
    const navigate = useNavigate();
    const { nuJobsCheckJDForApplyNowAfterLogin, nujobsApplyNow,linkstatus,myResumes,profileCompleted,nujobsUserMetaDataStats,
            nujobsReportIncompleteApplication,jdStatusAfterLogin,applicationStatusAfterLogin,
            resumeStatusAfterLogin,profileStatusAfterLogin} = useNuJobDetailsStore();
    const {resetApplyNowPopRouting } = useNuJobsStore(); 
    const [ jdValues, setJdValues] = useState({});    
    const { qhoid, qhcompanyjid } = useParams();

    
    function formatUnixDate(ts) {
      const d = new Date(ts * 1000);
      const mm = String(d.getMonth() + 1).padStart(2, "0");
      const dd = String(d.getDate()).padStart(2, "0");
      const yyyy = d.getFullYear();

      return `${dd}-${mm}-${yyyy}`;
    } 

    const initJDParams = (selectedJD) =>{
        var jdValuesTmp
            jdValuesTmp = {
                job_category: selectedJD?.JDDetails.JobCategory,
                title: selectedJD?.JDDetails.Title,
                client_job_type: selectedJD?.JDClient.ClientJobType,
                job_type: selectedJD?.JDDetails.JobType,
                job_time: selectedJD?.JDDetails.JobTime,
                designation: selectedJD?.JDDetails.Designation,
                roles_about: selectedJD?.JDRequired.AboutRole,
                roles_and_responsibility: selectedJD?.JDRequired.RoleDetails,
                roletype: selectedJD?.JDRequired.RoleType,
                role: selectedJD?.JDRequired.Role,
                skills: selectedJD?.JDRequired.Skills,
                additional_skills: selectedJD?.JDRequired.AdditionalSkills,                
                keywords: selectedJD?.JDRequired.Keywords,
                education: selectedJD?.JDRequired.Education,
                min_ctc: selectedJD?.JDProject.MinCtc,
                max_ctc: selectedJD?.JDProject.MaxCtc,
                postingdate: selectedJD?.JDOther.PostingDate,
                work_location: selectedJD?.JDRequired?.WorkLocation?.join(", "),
                work_mode: selectedJD?.JDRequired.WorkMode,
                diversity_only: selectedJD?.JDRequired.Diversity,
                freshers_only: selectedJD?.JDRequired.Fresher,
                interns_only: selectedJD?.JDRequired.Intern,                                                                          
                notice_period: selectedJD?.JDRequired.NoticePeriod,
                min_exp: selectedJD?.JDRequired.MinExperience,
                max_exp: selectedJD?.JDRequired.MaxExperience,
                updatedon: formatUnixDate(selectedJD?.timestamp),
                postedby: selectedJD?.CompanyName,  
                companylogo: selectedJD.companylogo,           
            };

            setJdValues(jdValuesTmp);
    }

    useEffect(() => {
        //get the stats
        nujobsUserMetaDataStats()

        //console.log("location", location.state);
        var eJson = encodeJson()
        nuJobsCheckJDForApplyNowAfterLogin(eJson,qhoid,qhcompanyjid,initJDParams)
    }, []);
   

   const encodeJson = () => {  
    let encodedJsonValues = {};
    const userData = JSON.parse(localStorage.getItem("nujobsUserDetails"));    
    //now override keyword and location
    encodedJsonValues.companyname = "";
    encodedJsonValues.nujoid = userData.nujoid;
    encodedJsonValues.nujuid = userData.nujuid;

    return encodedJsonValues;
  };

  const handleFormSubmit = async (values) => {
   // do nothing
  };

  const formatArrayToString = (array) => {
    return array
      ?.map((item) => item.charAt(0).toUpperCase() + item.slice(1))
      .join(", ");
  };
 
  const getCompanyLogoSrc = (rawLogo) => {
        if (!rawLogo) return null;
        if (rawLogo.startsWith("data:image")) return rawLogo;
        return `data:image/png;base64,${rawLogo}`;
    };
  const companyLogoSrc =
    getCompanyLogoSrc(
      jdValues?.companylogo ||
        jdValues?.CompanyLogo ||
        jdValues?.JDClient?.CompanyLogo,
    ) || null;

const  reportIncompleteApplication = () =>{
    let encodedJsonValues ={};
    //now override keyword and location
    encodedJsonValues.qhoid= qhoid;
    encodedJsonValues.qhcompanyjid=qhcompanyjid;
    nujobsReportIncompleteApplication(encodedJsonValues);
}
const handleApplyNow = () =>{
   navigate("/nujobshome/nujobssearch")  
}
const applyNowCallBackLoggedIn = () => {
        if(resumeStatusAfterLogin != "NO_RES" && profileStatusAfterLogin > 0){
                let encodedJsonValues ={};
                //now override keyword and location
                encodedJsonValues.qhoid= qhoid;
                encodedJsonValues.qhcompanyjid=qhcompanyjid;
                encodedJsonValues.companyname=jdValues.poastedby;  
                nujobsApplyNow(0, encodedJsonValues,handleApplyNow);
                resetApplyNowPopRouting()            
        }else{
            // Trigger the Modal only if NOT logged in
            Modal.confirm({
                title: "Missing Resume/ Incomplete Profile",
                content:
                "Upload Resume and Complete your Profile before Applying",
                okText: "OK",
                cancelButtonProps: { style: { display: "none" } },
                centered: true,
                closable: true,
                maskClosable: true,
                onCancel: () => {
                console.log("Modal closed or cancelled");
                },        
                footer: (
                <div
                    style={{
                    display: "flex",
                    justifyContent: "center",
                    width: "100%",
                    paddingBottom: "10px",
                    marginTop: "20px",
                    }}
                >
                    <Button
                    style={{
                        fontFamily: 'Segoe UI',               
                        color: "#7c8cce",
                        padding: "8px 14px",
                        borderRadius: "8px",
                        border: "10px",
                        border: "1px solid #96a5e2",
                        fontSize: "12px",
                        fontWeight: 600,
                        cursor: "pointer",
                        transition: "0.2s ease",
                        backgroundColor:"#fff"
                    }}
                    onClick={() => {
                        reportIncompleteApplication()
                        Modal.destroyAll(); // Close the modal manually
                        resetApplyNowPopRouting()
                        navigate("/nujobshome/nujobssearch")
                    }}
                    >
                    OK
                    </Button>
                </div>
                ),
            });            
        }

    };
    
  return (
    <div className="nuJobsApplyNowAfterLogin-form-wrapper">
      <div className="nuJobsViewJob-logo-container">
        <img className="nuJobsViewJob-logo-img" src={logo} />{" "}
      </div>
      <div className="jd-view-value-title" >{jdValues?.title || "-"} </div>
      {
        jdStatusAfterLogin == "LINK_EXPIRED"?
        <>
            <div style={{ textAlign: "center" }}>
            <h4>Link Expired</h4>
            <p>
                For more job opportunities, visit{" "}
                <a
                href="https://nujobs.quallyhireai.com"
                target="_blank"
                rel="noopener noreferrer"
                >
                Nujobs Job Platform
                </a>
            </p>
            </div>  
        </>
        :jdStatusAfterLogin == "JD_NOT_ACTIVE"?
        <>
            <div style={{ textAlign: "center" }}>
            <h4>Position Closed</h4>
            <p>
                For more job opportunities, visit{" "}
                <a
                href="https://nujobs.quallyhireai.com"
                target="_blank"
                rel="noopener noreferrer"
                >
                Nujobs Job Platform
                </a>
            </p>
            </div>             
        </>
        :<>
            <Form
                form = {form}
                key={formKey}
                className="jd-creation-form"
                justify="start"
                layout="vertical"
                autoComplete="off"
                onFinish={ handleFormSubmit}
                initialValues={jdValues}
                disabled={true}
>
  
                <div className="triple-input-wrapper">
                    <Form.Item 
                        className="jd-creation-field-item"
                        label="Job Category"
                        name="job_category"
                    >
                          <div className="jd-view-value">{jdValues?.job_category?.toUpperCase() || "-"}</div>                           
                    </Form.Item>                      
                    <Form.Item
                        className="jd-creation-field-item"
                        label="Job Type"
                        name="job_type"
                    >
                            <div className="jd-view-value">{jdValues?.job_type || "-"}</div>                      
                    </Form.Item>
                    <Form.Item
                            name="job_time"
                            className="jd-creation-field-item"
                            label="Job Time"
                        >
                            <div className="jd-view-value">{jdValues?.job_time || "-"}</div>       
                    </Form.Item>
                </div>

                <div className="triple-input-wrapper">
                    <Form.Item
                            name="designation"
                            className="jd-creation-field-item"
                            label="Designation"
                        >
                            <div className="jd-view-value">{jdValues?.designation || "-"}</div>       
                    </Form.Item> 
                    <Form.Item
                        name="roletype"
                        className="jd-creation-field-item"
                        label="Role Type"
                    >
                            <div className="jd-view-value">{jdValues?.roletype || "-"}</div>   
                    </Form.Item>   
                    <Form.Item
                        name="role"
                        className="jd-creation-field-item"
                        label="Role"
                    >
                            <div className="jd-view-value">{jdValues?.role || "-"}</div>  
                    </Form.Item>                   
                </div>
                    <Form.Item
                        name="role_about"
                        className="jd-creation-field-item"
                        label="About The Role"
                    >

                        <div
                            className="jd-creation-field-item"
                            dangerouslySetInnerHTML={{
                                __html: DOMPurify.sanitize(jdValues?.role_about || "-"),
                            }}
                        />                            
                    </Form.Item>                
                    <Form.Item
                        name="roles_and_responsibility"
                        className="jd-creation-field-item"
                        label="Roles & Responsibility"
                    >

                        <div
                            className="jd-creation-field-item"
                            dangerouslySetInnerHTML={{
                                __html: DOMPurify.sanitize(jdValues?.roles_and_responsibility || "-"),
                            }}
                        />                            
                    </Form.Item>
                    <Form.Item
                            name="skills"
                            className="jd-creation-field-item"
                            label="Required skills "
                    >   
                        <div
                            className="jd-creation-field-item"
                            dangerouslySetInnerHTML={{
                                __html: DOMPurify.sanitize(jdValues?.skills || "-"),
                            }}
                        />                                        
                    </Form.Item>
                    <Form.Item
                        name="additional_skills"
                        className="jd-creation-field-item"
                        label="Additional Skills"
                    >

                        <div
                            className="jd-creation-field-item"
                            dangerouslySetInnerHTML={{
                                __html: DOMPurify.sanitize(jdValues?.additional_skills || "-"),
                            }}
                        />                            
                    </Form.Item>

                   <div className="triple-input-wrapper">
                    <Form.Item
                        className="jd-creation-field-item"
                        label="Experience (Yrs) "
                    >
                        <Space style={{ display: "flex", gap: "8px" }}>
                        <Form.Item
                            className="jd-creation-field-item"
                            name="min_exp"
                        >
                            <div className="jd-view-value">{jdValues?.min_exp || "-"}</div>  
                        </Form.Item>
                                <Form.Item
                                    name="to"
                                    className="jd-creation-field-item"
                                >
                                    <div className="jd-view-value">{"to"}</div>  
                                </Form.Item>                        
                        <Form.Item
                            className="jd-creation-field-item"
                            name="max_exp"
                        >
                            <div className="jd-view-value">{jdValues?.max_exp || "-"}</div>  
                        </Form.Item>
                        </Space>
                    </Form.Item>
                    <Form.Item
                        className="jd-creation-field-item"
                        label="Offered CTC (LPA)"
                    >
                        <Space>
                                <Form.Item
                                    name="min_ctc"
                                    className="jd-creation-field-item"
                                >
                                    <div className="jd-view-value">{"Not Disclosed"}</div>  
                                </Form.Item>
                        </Space>
                    </Form.Item>
                    <Form.Item
                        className="jd-creation-field-item"
                        label="Notice Period"
                        name="notice_period"
                    >
                        <div className="jd-view-value">
                            {
                                jdValues?.notice_period != null
                                    ? jdValues.notice_period < 15
                                    ? "Immediate Joiners"
                                    : `${jdValues.notice_period} Days`
                                    : "-"
                            }
                        </div>  
                    </Form.Item>
                </div>

                <div className="triple-input-wrapper">
                    <Form.Item
                        name="education"
                        className="jd-creation-field-item"
                        label="Education"
                    >
            <div className="jd-view-value">
              {formatArrayToString(jdValues?.education?.[0]) || "-"}
            </div>
          </Form.Item>

                    <Form.Item  
                        name="work_location"
                        className="jd-creation-field-item"
                        label="Work Location"
                    >
                        <div className="jd-view-value">{jdValues?.work_location || "-"}</div>                         
                    </Form.Item>   


                    <Form.Item                          
                        name="work_mode"
                        className="jd-creation-field-item"
                        label="Work Mode"
                    >
                        <div className="jd-view-value">{jdValues?.work_mode || "-"}</div>          
                    </Form.Item>
                </div>

                <div className="triple-input-wrapper">
                    <Form.Item
                        name="diversity_only"
                        className="jd-creation-field-item"
                        label="Diversity Only"
                    >
                        <div className="jd-view-value">{jdValues?.diversity_only || "-"}</div>    
                    </Form.Item>
                    <Form.Item
                        name="freshers_only"
                        className="jd-creation-field-item"
                        label="Freshers Only"
                    >
                        <div className="jd-view-value">{jdValues?.freshers_only || "-"}</div> 
                    </Form.Item>
                    <Form.Item
                        name="interns_only"
                        className="jd-creation-field-item"
                        label="Interns Only"
                    >
                        <div className="jd-view-value">{jdValues?.interns_only || "-"}</div> 
                    </Form.Item>
                    
                </div>
                <div className="triple-input-wrapper">
                <Form.Item
                    name="postingdate"
                    className="jd-creation-field-item"
                    label="Posted On"
                >
                            <div className="jd-view-value">{jdValues?.postingdate || "-"}</div> 
                </Form.Item>
                <Form.Item
                    name="updatedon"
                    className="jd-creation-field-item"
                    label="Last Updated"
                >
                            <div className="jd-view-value">{jdValues?.updatedon || "-"}</div> 
                </Form.Item>                
                <Form.Item
                    name="postedby"
                    className="jd-creation-field-item"
                    label="Posted By"
                >
                            <div className="jd-view-value">{jdValues?.postedby || "-"}</div> 
                </Form.Item>
                </div>   
                {
                    applicationStatusAfterLogin=="Already Applied"?
                    <>
                        <Button
                                style={{ width: "100%", height: "40px", fontWeight: "600" }}
                                type="primary"
                                disabled={true}                  
                            >
                           Already Applied         
                        </Button>                     
                    </>
                    :<>
                        <Button
                                style={{ width: "100%", height: "40px", fontWeight: "600" }}
                                type="primary"
                                disabled={false}   
                                onClick={applyNowCallBackLoggedIn}                 
                            >
                            Apply Now         
                        </Button>                      
                    </>
                }               
            
            </Form>        
        </>
        
      }
    <div
    className="footer-menu"
    style={{
        marginTop: "20px",
        fontSize: "12px",
        textAlign: "center",
        color: "#666",
        lineHeight: "1.5"
    }}
    >
    <strong>Disclaimer:</strong> Applying through NuJobs does not guarantee
        selection, an interview, or employment. NuJobs does not permit employers to charge 
        candidates any fee for applying, interviewing, 
        or securing employment. Never make a payment to an employer 
        in connection with a job opportunity.
    </div>

    <div
    className="footer-menu"
    style={{
        marginTop: "10px",
        fontSize: "12px",
        textAlign: "center",
        color: "#666"
    }}
    >
    © 2026–2027 Copyright - NuJobs
    </div>
    </div>
    );
}
